export default __webpack_public_path__ + "static/media/category_08.afbfd087.png";